// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Card shell ───────────────────────────────────────────── */

.scl--cms-components-mediaChart-card {
  box-sizing: border-box;
  position: relative;
  flex: 1;
  height: 364px;
  background: var(--neutralcolors-100);
  border: 1px solid var(--neutralcolors-300);
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

/* ── Header ───────────────────────────────────────────────── */

.scl--cms-components-mediaChart-header {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 20px;
  height: 56px;
  border-bottom: 1px solid var(--neutralcolors-300);
  flex-shrink: 0;
  background: var(--neutralcolors-100);
  overflow: hidden;
  border-radius: 5px 5px 0 0;
}

.scl--cms-components-mediaChart-title {
  background: none;
  border: none;
  padding: 5px 20px 5px 0px;
  cursor: pointer;
  font-family: var(--font-family-inter);
  font-weight: 600;
  font-size: var(--font-size-18);
  line-height: var(--line-height-24);
  letter-spacing: var(--letter-spacing-6);
  color: var(--typography-text-body-primary);
  text-align: left;
}

.scl--cms-components-mediaChart-title:hover {
  text-decoration: underline;
}

/* ── Body ─────────────────────────────────────────────────── */

.scl--cms-components-mediaChart-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 13px;
  gap: 20px;
  flex: 1;
  min-height: 0;
  position: relative;
  overflow: visible;
}

/* ── Donut wrap ───────────────────────────────────────────── */

.scl--cms-components-mediaChart-donutWrap {
  position: relative;
  flex-shrink: 0;
  width: 207px;
  height: 207px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  overflow: visible;
}

/* ── Donut Center ─────────────────────────────────────────── */

.scl--cms-components-mediaChart-donutCenter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  pointer-events: none;
}

.scl--cms-components-mediaChart-donutLabel,
.scl--cms-components-mediaChart-donutSub {
  font-family: var(--font-family-inter);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-12);
  line-height: var(--line-height-20);
  color: var(--typography-text-body-secondary);
  text-align: center;
}

.scl--cms-components-mediaChart-donutValue {
  font-family: var(--font-family-inter);
  font-weight: 600;
  font-size: var(--font-size-36);
  line-height: var(--line-height-40);
  color: var(--typography-text-body-primary);
  text-align: center;
}

/* ── Tooltip ─────────────────────────────────────────────── */

.scl--cms-components-mediaChart-donutTooltip {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--neutralcolors-100);
  border: 1px solid var(--neutralcolors-400);
  box-shadow: 0px 0.735px 2.94px rgba(25, 33, 61, 0.08);
  border-radius: 3px;
  padding: 5px 8px;
  font-family: var(--font-family-inter);
  font-weight: 600;
  font-size: var(--font-size-12);
  line-height: var(--line-height-18);
  color: var(--neutralcolors-700);
  white-space: nowrap;
  pointer-events: none;
  z-index: 100;
  transition: opacity 0.2s ease, top 0.25s ease, left 0.25s ease;
}

.scl--cms-components-mediaChart-donutTooltipBeak {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid var(--neutralcolors-400);
}

.scl--cms-components-mediaChart-donutTooltipBeak::after {
  content: '';
  position: absolute;
  top: -7px;
  left: -5px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--neutralcolors-100);
}

/* ── Stats Panel ─────────────────────────────────────────── */

.scl--cms-components-mediaChart-stats {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  max-width: 266px;
}

/* Legend */

.scl--cms-components-mediaChart-legend {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 0;
  gap: 10px;
  border-bottom: 1px solid var(--neutralcolors-300);
  flex-shrink: 0;
}

.scl--cms-components-mediaChart-legendItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.scl--cms-components-mediaChart-legendDot {
  width: 8px;
  height: 8px;
  border-radius: 5px;
  flex-shrink: 0;
}

.scl--cms-components-mediaChart-legendName {
  font-family: var(--font-family-inter);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-16);
  line-height: var(--line-height-22);
  color: var(--typography-text-body-primary);
}

.scl--cms-components-mediaChart-legendCount {
  font-family: var(--font-family-inter);
  font-weight: 600;
  font-size: var(--font-size-18);
  line-height: var(--line-height-24);
  color: var(--typography-text-body-primary);
}

/* Stats */

.scl--cms-components-mediaChart-bars {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
}

.scl--cms-components-mediaChart-statItem {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.scl--cms-components-mediaChart-statHeading {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.scl--cms-components-mediaChart-statLabel {
  font-family: var(--font-family-inter);
  font-weight: 500;
  font-size: var(--font-size-14);
  line-height: var(--line-height-20);
  color: var(--typography-text-body-secondary);
}

.scl--cms-components-mediaChart-statValue {
  font-family: var(--font-family-inter);
  font-weight: 600;
  font-size: var(--font-size-18);
  line-height: var(--line-height-24);
  color: var(--typography-text-body-primary);
}

.scl--cms-components-mediaChart-track {
  width: 100%;
  height: 10px;
  background: var(--neutralcolors-300);
  box-shadow: inset 0px 2px 2px rgba(165, 165, 165, 0.04);
  border-radius: 6px;
  overflow: hidden;
}

.scl--cms-components-mediaChart-bar {
  height: 100%;
  border-radius: 6px;
}

/* ── Footer ─────────────────────────────────────────────── */

.scl--cms-components-mediaChart-footer {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 10px;
  height: 52px;
  background: var(--neutralcolors-100);
  border-top: 1px solid var(--neutralcolors-300);
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 0 0 5px 5px;
}

.scl--cms-components-mediaChart-footerLink {
  font-family: var(--font-family-inter);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-14);
  line-height: var(--line-height-20);
  letter-spacing: var(--letter-spacing-4);
  color: var(--primarypalette-blue);
  text-decoration: none;
}

.scl--cms-components-mediaChart-footerLink:hover {
  text-decoration: underline;
}

.scl--cms-components-mediaChart-openBtn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: var(--font-family-inter);
  font-weight: 600;
  font-size: var(--font-size-14);
  line-height: var(--line-height-20);
  color: var(--secondarycolors-blue400);
  padding: 0;
  flex-shrink: 0;
  text-decoration: none;
}

.scl--cms-components-mediaChart-openBtn:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/dashboard-fs-cp/media-dsb-op/media-chart/css/mediaChart.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;EACE,sBAAsB;EACtB,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,oCAAoC;EACpC,0CAA0C;EAC1C,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,gEAAgE;;AAEhE;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iDAAiD;EACjD,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,uCAAuC;EACvC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gEAAgE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gEAAgE;;AAEhE;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA,gEAAgE;;AAEhE;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,+DAA+D;;AAE/D;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA,+DAA+D;;AAE/D;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,uDAAuD;EACvD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,8DAA8D;;AAE9D;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,8CAA8C;EAC9C,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,uCAAuC;EACvC,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,qCAAqC;EACrC,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* ── Card shell ───────────────────────────────────────────── */\n\n.scl--cms-components-mediaChart-card {\n  box-sizing: border-box;\n  position: relative;\n  flex: 1;\n  height: 364px;\n  background: var(--neutralcolors-100);\n  border: 1px solid var(--neutralcolors-300);\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n}\n\n/* ── Header ───────────────────────────────────────────────── */\n\n.scl--cms-components-mediaChart-header {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 16px 20px;\n  height: 56px;\n  border-bottom: 1px solid var(--neutralcolors-300);\n  flex-shrink: 0;\n  background: var(--neutralcolors-100);\n  overflow: hidden;\n  border-radius: 5px 5px 0 0;\n}\n\n.scl--cms-components-mediaChart-title {\n  background: none;\n  border: none;\n  padding: 5px 20px 5px 0px;\n  cursor: pointer;\n  font-family: var(--font-family-inter);\n  font-weight: 600;\n  font-size: var(--font-size-18);\n  line-height: var(--line-height-24);\n  letter-spacing: var(--letter-spacing-6);\n  color: var(--typography-text-body-primary);\n  text-align: left;\n}\n\n.scl--cms-components-mediaChart-title:hover {\n  text-decoration: underline;\n}\n\n/* ── Body ─────────────────────────────────────────────────── */\n\n.scl--cms-components-mediaChart-body {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 16px 13px;\n  gap: 20px;\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  overflow: visible;\n}\n\n/* ── Donut wrap ───────────────────────────────────────────── */\n\n.scl--cms-components-mediaChart-donutWrap {\n  position: relative;\n  flex-shrink: 0;\n  width: 207px;\n  height: 207px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: default;\n  overflow: visible;\n}\n\n/* ── Donut Center ─────────────────────────────────────────── */\n\n.scl--cms-components-mediaChart-donutCenter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  pointer-events: none;\n}\n\n.scl--cms-components-mediaChart-donutLabel,\n.scl--cms-components-mediaChart-donutSub {\n  font-family: var(--font-family-inter);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-12);\n  line-height: var(--line-height-20);\n  color: var(--typography-text-body-secondary);\n  text-align: center;\n}\n\n.scl--cms-components-mediaChart-donutValue {\n  font-family: var(--font-family-inter);\n  font-weight: 600;\n  font-size: var(--font-size-36);\n  line-height: var(--line-height-40);\n  color: var(--typography-text-body-primary);\n  text-align: center;\n}\n\n/* ── Tooltip ─────────────────────────────────────────────── */\n\n.scl--cms-components-mediaChart-donutTooltip {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: var(--neutralcolors-100);\n  border: 1px solid var(--neutralcolors-400);\n  box-shadow: 0px 0.735px 2.94px rgba(25, 33, 61, 0.08);\n  border-radius: 3px;\n  padding: 5px 8px;\n  font-family: var(--font-family-inter);\n  font-weight: 600;\n  font-size: var(--font-size-12);\n  line-height: var(--line-height-18);\n  color: var(--neutralcolors-700);\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 100;\n  transition: opacity 0.2s ease, top 0.25s ease, left 0.25s ease;\n}\n\n.scl--cms-components-mediaChart-donutTooltipBeak {\n  position: absolute;\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid var(--neutralcolors-400);\n}\n\n.scl--cms-components-mediaChart-donutTooltipBeak::after {\n  content: '';\n  position: absolute;\n  top: -7px;\n  left: -5px;\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid var(--neutralcolors-100);\n}\n\n/* ── Stats Panel ─────────────────────────────────────────── */\n\n.scl--cms-components-mediaChart-stats {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n  max-width: 266px;\n}\n\n/* Legend */\n\n.scl--cms-components-mediaChart-legend {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 0;\n  gap: 10px;\n  border-bottom: 1px solid var(--neutralcolors-300);\n  flex-shrink: 0;\n}\n\n.scl--cms-components-mediaChart-legendItem {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.scl--cms-components-mediaChart-legendDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 5px;\n  flex-shrink: 0;\n}\n\n.scl--cms-components-mediaChart-legendName {\n  font-family: var(--font-family-inter);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-16);\n  line-height: var(--line-height-22);\n  color: var(--typography-text-body-primary);\n}\n\n.scl--cms-components-mediaChart-legendCount {\n  font-family: var(--font-family-inter);\n  font-weight: 600;\n  font-size: var(--font-size-18);\n  line-height: var(--line-height-24);\n  color: var(--typography-text-body-primary);\n}\n\n/* Stats */\n\n.scl--cms-components-mediaChart-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n}\n\n.scl--cms-components-mediaChart-statItem {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.scl--cms-components-mediaChart-statHeading {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.scl--cms-components-mediaChart-statLabel {\n  font-family: var(--font-family-inter);\n  font-weight: 500;\n  font-size: var(--font-size-14);\n  line-height: var(--line-height-20);\n  color: var(--typography-text-body-secondary);\n}\n\n.scl--cms-components-mediaChart-statValue {\n  font-family: var(--font-family-inter);\n  font-weight: 600;\n  font-size: var(--font-size-18);\n  line-height: var(--line-height-24);\n  color: var(--typography-text-body-primary);\n}\n\n.scl--cms-components-mediaChart-track {\n  width: 100%;\n  height: 10px;\n  background: var(--neutralcolors-300);\n  box-shadow: inset 0px 2px 2px rgba(165, 165, 165, 0.04);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.scl--cms-components-mediaChart-bar {\n  height: 100%;\n  border-radius: 6px;\n}\n\n/* ── Footer ─────────────────────────────────────────────── */\n\n.scl--cms-components-mediaChart-footer {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 10px;\n  height: 52px;\n  background: var(--neutralcolors-100);\n  border-top: 1px solid var(--neutralcolors-300);\n  flex-shrink: 0;\n  overflow: hidden;\n  border-radius: 0 0 5px 5px;\n}\n\n.scl--cms-components-mediaChart-footerLink {\n  font-family: var(--font-family-inter);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-14);\n  line-height: var(--line-height-20);\n  letter-spacing: var(--letter-spacing-4);\n  color: var(--primarypalette-blue);\n  text-decoration: none;\n}\n\n.scl--cms-components-mediaChart-footerLink:hover {\n  text-decoration: underline;\n}\n\n.scl--cms-components-mediaChart-openBtn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: var(--font-family-inter);\n  font-weight: 600;\n  font-size: var(--font-size-14);\n  line-height: var(--line-height-20);\n  color: var(--secondarycolors-blue400);\n  padding: 0;\n  flex-shrink: 0;\n  text-decoration: none;\n}\n\n.scl--cms-components-mediaChart-openBtn:hover {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
